<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="6" class="text-start">
                                <strong>Destination Group Master</strong>
                            </b-col>
                            <b-col md="6" class="text-right">
                                <b-button variant="primary" size="sm" @click="addorigin()"><i class="fa fa-plus" aria-hidden="true"></i>
                                    Add Destinations Group 
                                </b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="search()"><i class="fa fa-search" aria-hidden="true"></i> Search</b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="restclear()"><i class="fa fa-search"></i> Reset Search Filter</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="add_destinationgroupinfo">
                        <div>
  
                            <h4>Add Destination Group</h4>
                            <hr>
                            <b-form
                            @submit.prevent="validateForm('form-1')"
                            data-vv-scope="form-1">
                            <div class="row mt-3">
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Client Name</b> <span style="color:red;"> *</span></label>
                                        <v-select name="Destination Client Name" v-model="customer.destinationClientName" :options="clientname" placeholder="select Destination Client Name" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination Client Name'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Destination Client Name')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Destination Client Name')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Destination Client Name") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                 <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Client Service </b> <span style="color:red;"> *</span></label>
                                        <v-select name="Client Service" v-model="customer.destinationclientservice" 
                                        placeholder="select destination client service" :options="destitserive" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Client Service'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Client Service')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Client Service')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Client Service") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <!-- <b-form-group>
                                        <label><b>Origin State</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input name="destinationState" placeholder="Origin State" v-model="customer.destinationState" :options="destistate" v-validate="'required|alpha_spaces'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.destinationState'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('destinationState')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.destinationState')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.destinationState") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group> -->
                                    <b-form-group>
                                        <label><b>Origin State</b> <span style="color:red;"> *</span></label>
                                        <v-select name="Origin State" v-model="customer.destinationState" @input="selectstate('city',customer.destinationState)" 
                                        placeholder="Select Origin State" :options="StateList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin State'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Origin State')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Origin State')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Origin State") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                
                                <!-- ~~~~~~~~~~~~~~ -->        
                                <div class="col-md-4">
                                    <!-- <b-form-group>
                                        <label><b>Origin City</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input name="destinationCity" v-model="customer.destinationCity" :options="desticity" placeholder="Origin City" v-validate="'required|alpha_spaces'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.destinationCity'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('destinationCity')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.destinationCity')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.destinationCity") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group> -->

                                    <b-form-group>
                                        <label><b>Origin City</b> <span style="color:red;">  *</span></label>
                                        <v-select name="Origin City" v-model="customer.destinationCity" @input="selectcity('pincode',customer.destinationState,customer.destinationCity)" :disabled="!customer.destinationState"
                                        placeholder="Select Origin City" :options="CityList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin City'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Origin City')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Origin City')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Origin City") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Group Name</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input name="Destination Group Name"     v-model.trim="customer.destinationgroupname" placeholder="Group Name" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination Group Name'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Destination Group Name')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Destination Group Name')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Destination Group Name") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>  
                                <div class="col-md-4">
                                    <!-- <b-form-group>
                                        <label><b>Group Pin-code</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input name="destinationgroupincode" v-model="customer.destinationgroupincode" placeholder="Group pin-code" maxlength="6" class="italic-placeholder" v-validate="'required|digits:6'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.destinationgroupincode'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('destinationgroupincode')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.destinationgroupincode')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.destinationgroupincode") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group> -->

                                    <b-form-group>
                                        <label><b>Group Pin-code</b> <span style="color:red;"> *</span></label>
                                        <v-select name="Group Pin-code" v-model="customer.destinationgroupincode" :disabled="!customer.destinationCity"
                                        placeholder="Select Group Pin-code" :options="PincodeList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Group Pin-code'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Group Pin-code')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Group Pin-code')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Group Pin-code") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Thresh Hold Distance</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input placeholder="Thresh Hold Distance" name="Destination Group Threshhold Dist" v-model.number="customer.destinationgroupthreshholddist" class="italic-placeholder" v-validate="'required|decimal:3'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination Group Threshhold Dist'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Destination Group Threshhold Dist')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Destination Group Threshhold Dist')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Destination Group Threshhold Dist") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>   
                                <div class="col-md-8 mt-4 text-right">
                                    <b-button variant="primary" type="submit" class="mr-2"><i class="fa fa-dot-circle-o"></i> Add</b-button>
                                    <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                </div>       
                            </div>
                            </b-form>
                        </div>
                    </div>

                    <div v-if="search_groupdes">
                        <div>
      
                            <h4>Search Destination Group</h4>
                            <hr>
                            <div class="row mt-3">
                             <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination Group Name</b></label>
                                        <b-input-group>
                                            <b-form-input name="destinationgroupname" v-model.trim="destinationgroupname" placeholder="Group Name" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div> 
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Client Service </b></label>
                                        <v-select name="destinationClientName" v-model="destinationClientName" class="italic-placeholder" placeholder="select Destination Client Name" :options="destitserive"></v-select>
                                    </b-form-group>
                                </div>
                                 
                
                                <!-- ~~~~~~~~~~~~~~ -->        
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination City</b></label>
                                        <b-input-group>
                                            <b-form-input name="destinationCity" v-model.trim="destinationCity" class="italic-placeholder" placeholder="Destination City"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12 text-right">
                                    <b-button  variant="primary" @click="desgroupmasterList(pageNum)" class="mr-2"><i class="fa fa-dot-circle-o"></i> Search</b-button>
                                    <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br><br>

                    <div>
                        <b-row>
                            <b-col md="12" class="text-right">
                                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                            </b-col>
                            <b-col md="12">
                                <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                    <template slot="sno" slot-scope="row">
                                        <div>
                                            {{ row.index+1 }}
                                        </div>
                                    </template>
                                    <template slot="allocate_destination" slot-scope="row">
                                        <div>
                                            <b-button size="sm" @click="allocatedcity(row.item)"><i class="fa fa-eye" ></i></b-button>
                                        </div>
                                    </template>
                                    <template slot="action" slot-scope="row">
                                        <div>
                                            <b-button size="sm" @click="editdestination(row.item)"><i class="fa fa-pencil" ></i></b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="12" class="text-right">
                          <br>
                               <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                        </b-col>
                        <b-col md="12" class="my-1" >
                            <paginate 
                            v-model="pageNum"
                                :page-count="noofpages"
                                :page-range="10"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                            </paginate>
                        </b-col>   
                    </b-row> 

                    <b-modal title="Update Destination Group Master" v-model="showEditDestinationGroupModal" size="lg" @ok="showEditDestinationGroupModal = false" hide-footer>
                        <div>
                            <div id="listloader" v-if="listloader">
                                <div class="listloader"></div>
                            </div>
                            <div class="row mt-3">
                                <div id="overlaymodel" >
                                    <div class="modelloader"></div>
                                  </div>
                                <div class="col-md-6">
                                    <b-form-group>
                                        <label><b>Group Name</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input name="destinationgroupname" disabled v-model.trim="group_name" placeholder="Group Name" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>        
                                <div class="col-md-6">
                                    <!-- <b-form-group>
                                        <label><b>Destination City</b></label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group>
                                            <b-form-input name="destinationCity" v-model="user.origin_city" placeholder="Destination City"></b-form-input>
                                        </b-input-group>
                                    </b-form-group> -->

                                    <b-form-group>
                                        <label><b>Destination City</b></label>&nbsp;<span style="color: red;">*</span>
                                        <v-select v-model="user.origin_city"
                                        placeholder="Select Destination City" :options="editAllCityList" @input="getCityWiseVendor()"></v-select>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12">    
                                    <label><b>Destination Name</b></label>&nbsp;<span style="color: red;">*</span>
                                    <div v-if="Destinationlist.length>0">
                                        <b-card style="width: 740px; height: 250px; overflow: scroll;">
                                            <input type="checkbox" @click="checkAll()" v-model="isCheckAll"> &nbsp;
                                            <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">Select All</span>
                                            <ul>
                                              <li v-for="item in Destinationlist" :key="item.id">
                                                <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="item.destinationpincode" @change="multiselectdesign($event,item)"  v-model='checkedpincode' />
                                                &nbsp;&nbsp;
                                                <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">
                                                  {{ item.destination_name }} ({{ item.destinationcity }} - {{ item.userid }} {{item.distance ? '-' : ''  }} {{ item.distance }} {{ item.distance ? 'Km' : '' }})
                                                </span>
                                              </li>
                                            </ul>
                                        </b-card>
                                    </div>
                                    <div v-if="editdestinationmapcity">
                                        <h5><pre>{{editdestinationmapcity}}</pre></h5>
                                    </div>
                                    <div v-if="destinationmapcity" class="text-center">
                                        <h5><pre>{{destinationmapcity}}</pre></h5>
                                    </div>
                                </div>
                           
                                <div class="col-md-12 text-right">
                                    <b-button variant="primary" @click="Updategroupdestination()" class="mr-2"><i class="fa fa-dot-circle-o"></i> Save</b-button>
                                    <b-button variant="danger" @click="clear('ok')" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                </div>
                            </div>
                            
                        </div>
                    </b-modal>

                    <b-modal title="Allocated Destination" v-model="showallocatedModal" size="lg" @ok="showallocatedModal = false" hide-footer>
                        <div id="listloader" v-if="listloader">
                            <div class="listloader"></div>
                        </div>
                        <div v-if="allocatepincodelist.length>0">
                            <ul>
                                <li v-for="item in allocatepincodelist">
                                    <input type="checkbox" v-model="checkall" disabled>&nbsp;&nbsp;
                                    <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">{{ item.destination_name }} ({{ item.destinationcity }} - {{ item.userid }} {{item.distance ? '-' : ''  }} {{ item.distance }} {{ item.distance ? 'Km' : '' }})</span>
                                </li>
                            </ul>
                        </div>
                        <div v-if="destinationmapcity" class="text-center">
                            <h5><pre>{{destinationmapcity}}</pre></h5>
                        </div>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
    data() {
        return {
            listloader : false,
            isBusy : false,
            totalRows :0,
            items :[],
            fields :[
                {key:'sno',label:'S.No'},
                {key:'origin_city',label:'Group City'},
                {key:'clientname',label:'Client Name'},
                {key:'group_name',label:'Group Name'},
                {key:'destinationgroup_id',label:'Group ID'},
                {key:'client_service',label:'Client Service'},
                {key:'allocate_destination',label:'Allocated Destination'},
                {key:'createdby',label:'Created By'},
                {key:'createddate',label:'Created Date'},
                {key:'lastmodifiedby',label:'Updated By'},
                {key:'lastmodifieddate',label:'Updated Date'},
                {key:'action',label:'Action'},

            ],

            //add start
            add_destinationgroupinfo : false,
            customer :{},
            clientnamelist: [],
            clientname :[],
            destitserive :["B2B","B2C"],
            //add end

            //search add
            search_groupdes :false,
            destinationgroupname :'',
            destinationClientName :'',
            destinationCity :'',
            //search end

            //pagination satrt
            currentPage: 1,
            perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            //pagi end 

            //edit model
            showEditDestinationGroupModal:false,
            user:{},
            isCheckAll: true,
            selectedItems: [],
            checkedpincode :[],
            unselectpincode : [],
            group_name : '',
            editdestinationmapcity : '',
            editCityList :[],
            //end edit

            //allocate model

            showallocatedModal : false,
            Destinationlist:[],
            checkall : true,
            destinationmapcity : '',
            allocatepincodelist :[],

             //country
            Obj :{},
            country:["India"],
            item_state :[],
            StateList:[],
            item_city : [],
            CityList : [],
            item_pincode : [],
            PincodeList : [],
            originstate : "",
            getDestGroupData:{},
            allCity:[],
            editAllCityList:[],
            userdestinationgroup_id:''
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("YUUUUU", userInfo);
        this.allclientlist()
        this.desgroupmasterList(this.pageNum)
        this.getStateList('country')
    },

    methods: {
        addorigin(){
            this.clear()
            // this.allclientlist()
            // this.getStateList('country')
            this.add_destinationgroupinfo=!this.add_destinationgroupinfo;
            this.search_groupdes=false;
        },

        search(){
            this.clear()
            this.search_groupdes=!this.search_groupdes;
            this.add_destinationgroupinfo=false;
        },

        restclear(){
            this.search_groupdes=false;
            this.add_destinationgroupinfo=false;
            this.pageNum=1;
            this.totalRows = 0;
            this.customer ={}
            this.user = {}
            this.destinationgroupname ='';
            this.destinationClientName ='';
            this.destinationCity ='';
            this.isCheckAll = false;
            this.unselectpincode =[];
            this.checkedpincode =[];
            this.item_state = [];
            this.StateList = [];
            this.item_city = [];
            this.CityList = [];
            this.item_pincode = [];
            this.PincodeList = [];
            this.allCity=[];
            this.desgroupmasterList(this.pageNum)
            this.getStateList('country')
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist()   
        },

        clear(value){
            this.pageNum=1;
            this.totalRows = 0;
            this.customer ={}
            this.user = {}
            this.destinationgroupname ='';
            this.destinationClientName ='';
            this.destinationCity ='';
            this.isCheckAll = false;
            this.unselectpincode =[];
            this.checkedpincode =[];
            this.item_state = [];
            this.StateList = [];
            this.item_city = [];
            this.CityList = [];
            this.item_pincode = [];
            this.PincodeList = [];
            this.allCity=[];
            this.desgroupmasterList(this.pageNum)
            this.getStateList('country')
            if (value=='ok') {
                this.getStateList('city',this.originstate)   
            }
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist()   
        },

        allclientlist(){
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getallclientlist`,Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.clientnamelist = result.body.returnvalue;

                    this.clientnamelist.forEach(value => {
                        var client = {
                            key:value.clientmasterid,
                            label:value.clientname
                        }
                        this.clientname.push(client)
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.customer.destinationClientName = client;
                        }
                    });
            
                } else {
                    this.clientnamelist =[];
                    this.clientname =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.adddestination_grmasterinfo();
                }
            });
        },

        adddestination_grmasterinfo(){
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                sysusermasterid : `${userInfo.sysusermasterid}`,
                client_id : `${this.customer.destinationClientName==null?'':this.customer.destinationClientName.key}`,
                client_service : this.customer.destinationclientservice,
                origin_state : this.customer.destinationState,
                origin_city : this.customer.destinationCity,
                group_name : this.customer.destinationgroupname,
                group_pincode : this.customer.destinationgroupincode,
                threshhold_distance : `${this.customer.destinationgroupthreshholddist}`,
                createdby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addDestinationGroup`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.add_destinationgroupinfo = false;
                this.desgroupmasterList(this.pageNum)
                this.clear();
                this.customer = {};
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.desgroupmasterList(pageNum);
        },

        desgroupmasterList(pageNum){
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                sysusermasterid :`${userInfo.sysusermasterid}`,
                page_no : pageNum,
                group_name : this.destinationgroupname.trim(),
                destination_city :this.destinationCity.trim(),
                client_service : `${this.destinationClientName}`,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getdestinationgroupmasterList`,Obj)
            .then((result) => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.totalcount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
            
                } else {
                    this.items =[];
                    this.totalRows =0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        editdestination(value){
            this.checkedpincode = [];
            this.unselectpincode = [];
            this.user = {};
            this.group_name ='';
            this.originstate ='';
            this.unselectpincode =[];
            this.Destinationlist =[];
            this.editCityList = [];
            this.destinationmapcity ='';
            this.editdestinationmapcity ='';
            this.getDestGroupData= {};
            // this.isCheckAll = true
            this.search_groupdes=false;
            this.add_destinationgroupinfo=false;
            this.group_name = value.group_name;
            this.user.origin_city = value.origin_city;

            this.originstate = value.origin_state;
            this.getDestGroupData=value;
            console.log("getDestGroupData------------->",value);
            this.getAllCity();
            // if (value.origin_city!=null && value.origin_city!=undefined) {
            //     this.getStateList('city',value.origin_state)
            // }

            this.userdestinationgroup_id = value.destinationgroup_id;
        
            this.showEditDestinationGroupModal = true;

            if (value.is_not_mapped=='Yes') {
                this.editdestinationmapcity = 'Group Pincode is not map destinaion Master'
            }
            else{
                this.getDestinationlist(value)
            }

        },

        Updategroupdestination(){
            document.getElementById("overlaymodel").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            // if (this.checkedpincode==0) {
            //     this.$fire({
            //             text: 'Please Select AT Least One Destination Name',
            //             type: "error",
            //             timer: 30000,
            //         });
            //         document.getElementById("overlaymodel").style.display = "none";
            //         return false;
            // }
            const Obj = {
                sysusermasterid : `${userInfo.sysusermasterid}`,
                // group_name :  this.user.group_name,
                destinationgroup_id : `${this.userdestinationgroup_id}`,
                destination_city :  this.user.origin_city,
                lastmodifiedby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                is_check : this.checkedpincode,
                is_uncheck : this.unselectpincode,
            }
            console.log("Obj",Obj)
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/editDestinationGroup`,Obj)
            .then((result) => {
                document.getElementById("overlaymodel").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: 'Destination Group Master Edited Successfully',
                    type: "success",
                    timer: 30000,
                });
                this.showEditDestinationGroupModal = false;
                
                this.desgroupmasterList(this.pageNum)
                this.clear();
                this.user = {};
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        allocatedcity(data){
            this.allocatepincodelist =[]
            this.Destinationlist = [];
            this.destinationmapcity = '';
            this.showallocatedModal =! this.showallocatedModal;
            if (data.is_not_mapped=='Yes') {
                this.destinationmapcity = 'Group Pincode is not map destinaion Master'
            }
            else{
                this.getDestinationlist(data)
            }

        },

        getDestinationlist (data){
            // console.log('getDestinationlist----------------------->',data);
            this.allocatepincodelist =[]
            this.unselectpincode = [];
            this.Destinationlist =[]
            this.destinationmapcity =''
            this.editdestinationmapcity ='';
            this.checkedpincode = []
            this.listloader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                sysusermasterid : `${userInfo.sysusermasterid}`,
                destinationgroup_id : `${data.destinationgroup_id}`,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getAllocatedDestinationList`,Obj)
            .then((result) => {
                this.listloader = false;
                if (result.body.returnmsg === "Successful") {
                    this.Destinationlist = result.body.returnvalue;
                    for (let i = 0; i <  this.Destinationlist.length; i++) {
                        if (this.Destinationlist[i].is_check=='Yes') {
                            this.checkedpincode.push(this.Destinationlist[i].destinationpincode);
                        }
                        
                    }
                    if (this.checkedpincode.length==this.Destinationlist.length) {
                        this.isCheckAll = true
                    }
                    else{
                        this.isCheckAll = false
                    }
                    console.log("this.checkedpincode",this.checkedpincode.length)
                    console.log("this.Destinationlist.length",this.Destinationlist.length)
                    for (let i = 0; i <  this.Destinationlist.length; i++) {
                        if (this.Destinationlist[i].is_check=='Yes') {
                            this.allocatepincodelist.push(this.Destinationlist[i]);
                        }
                        
                    }
                } else {
                    this.Destinationlist =[];
                    this.destinationmapcity = 'Group Pincode is not map destinaion Master'
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        checkAll: function(){

            this.isCheckAll = !this.isCheckAll;
            this.checkedpincode = [];
            this.unselectpincode = [];
            
            if(this.isCheckAll){ // Check all

            for (var key in this.Destinationlist) {
                    this.checkedpincode.push(this.Destinationlist[key].destinationpincode);
                    this.unselectpincode = [];
                }
            }
            else{
                for (var key in this.Destinationlist) {
                    this.unselectpincode.push(this.Destinationlist[key].destinationpincode);
                    console.log(" this.unselectpincode", this.unselectpincode)
                    this.checkedpincode = [];
                }
            }
        },

        multiselectdesign(e,value){

            if (e.target.checked==false) {
                this.unselectpincode.push(value.destinationpincode)
                console.log(" this.unselectpincode", this.unselectpincode)
            }
    
            if (e.target.checked==true) {
                this.unselectpincode = this.unselectpincode.filter(code => code !== value.destinationpincode)
                console.log(" this.unselectpincode", this.unselectpincode)
            }

            if (this.checkedpincode.length >=0)

            {
                if(this.checkedpincode.length == this.Destinationlist.length){
                    this.isCheckAll = true;
                }
                else{
                    this.isCheckAll = false;
                }
            }
            else{
                if(this.checkedpincode.length == 0){
                    this.isCheckAll = false;
                }  
            }
        },

         // add start
        selectcountry(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            // if (value=='state') {
            //     this.getStateList('state',country)
            // }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationCountry='';
                this.customer.destinationState='';
                this.customer.destinationCity='';
                this.customer.destinationPincode='';
            }
        },
        
        selectstate(value,state){
            if (value=='city') {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationCity='';
                this.customer.destinationgroupincode='';
                this.getStateList('city',state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationState='';
                this.customer.destinationCity='';
                this.customer.destinationgroupincode='';
                this.getStateList('country')
            }
        },

        selectcity(value,state,city){
            if (value=='pincode') {
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationgroupincode='';
                this.getStateList('pincode',state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationCity='';
                this.customer.destinationgroupincode='';
                this.getStateList('city',state)
            }
        },

        // add end

        // edit
        getStateList(value,state,city){
            this.editCityList =[]
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            if (value=='country') {
                this.Obj = {
                    country : "",
                    state : "",
                    city : "",
                    pincode : ""
                }
            }
            if (value=='city') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : "",
                    pincode : ""
                }
            }

            if (value=='pincode') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : city,
                    pincode : ""
                }
            }

            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getStateCityPincodes`,this.Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    if (value=='country') {
                        this.item_state = [];
                        this.StateList = [];
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_state = result.body.returnvalue;
                        this.item_state.forEach(value => {
                            this.StateList.push(value.state)
                        });
                    }

                    if (value=='city') {
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_city = result.body.returnvalue;
                        this.item_city.forEach(value => {
                            this.CityList.push(value.city)
                        });
                        this.item_city.forEach(value => {
                            this.editCityList.push(value.city)
                        });
                    }

                    if (value=='pincode') {
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_pincode = result.body.returnvalue;
                        this.item_pincode.forEach(value => {
                            this.PincodeList.push(value.pincode)
                        });
                    }
                } 
                else {
                    this.item_state = [];
                    this.StateList = [];
                    this.item_city = [];
                    this.CityList = [];
                    this.item_pincode = [];
                    this.PincodeList = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        getCityWiseVendor(){
            
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            let payloadObj={
                destination_city:`${this.user.origin_city}`,
                destinationgroup_id:`${this.getDestGroupData.destinationgroup_id}`,
                lastmodifiedby:`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                group_pincode:`${this.getDestGroupData.group_pincode}`,
            }
            // console.log('----------------------->',payloadObj)
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/insertDestinationCityDistanceAndVendors`,payloadObj).then((response)=>{
             console.log("response------------------>",response)
             if(response.body.returnmsg=='Successful'){
                this.getDestinationlist(this.getDestGroupData)
                this.$fire({
                        text: response.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                   
             }else{
                this.$fire({
                        text: response.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
             }
            }).catch((err)=>{
                console.log("Error------------>",err)
            })
        },
        getAllCity(){
          this.item_city = [];
          this.CityList = [];
          this.editAllCityList=[];
          let cityObj={};
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/apiToGetAllCity`,cityObj).then((response)=>{
            if(response.body.returnmsg=='Successful'){
              this.allCity=response.body.returnvalue;
              this.allCity.forEach(value=>{
                this.editAllCityList.push(value.city)
              })
            }else{
                this.$fire({
                    text: response.body.returnvalue,
                    type: "error",
                    timer: 30000,
                });
            }
          }).catch((err)=>{
            console.log("Error------------>",err)
          })
        }
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>